import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-darkGrey border-t border-electricBlue/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center">
              <span className="text-neonGreen font-bold text-xl">IMAGINATION</span>
              <span className="text-electricBlue font-bold text-xl ml-1">LABS</span>
            </div>
            <p className="mt-4 text-gray-300 max-w-md">
              Practical websites, AI, automation, and custom software for small businesses. Powerful technology, within reach.
            </p>

          </div>
          
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <FooterLink to="/">Home</FooterLink>
              <FooterLink to="/research">The Lab</FooterLink>
              <FooterLink to="/solutions">Solutions</FooterLink>
              <FooterLink to="/about">About Us</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Let’s talk</h3>
            <p className="text-gray-300 mb-3">What would you like to make easier?</p>
            <a href="mailto:ImaginationLabsUSA@gmail.com" className="text-electricBlue hover:text-neonGreen break-words">ImaginationLabsUSA@gmail.com</a>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-electricBlue/10 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} ImaginationLabs. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

const FooterLink = ({ to, children }) => (
  <li>
    <Link 
      to={to} 
      className="text-gray-400 hover:text-neonGreen transition-colors duration-200"
    >
      {children}
    </Link>
  </li>
);

export default Footer; 